
import Layout from "@/components/layout/Layout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import InverterApiForm from "@/components/inverterApi/InverterApiForm";
import InverterApiList from "@/components/inverterApi/InverterApiList";
import ApiDocsReference from "@/components/inverterApi/ApiDocsReference";

const InverterApiPage = () => {
  return (
    <Layout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold">APIs de Inversores</h1>
          <p className="text-muted-foreground mt-2">
            Gerencie as conexões com APIs dos fabricantes de inversores solares
          </p>
        </div>

        <Tabs defaultValue="list" className="w-full">
          <TabsList className="mb-6">
            <TabsTrigger value="list">Lista de APIs</TabsTrigger>
            <TabsTrigger value="add">Cadastrar Nova</TabsTrigger>
            <TabsTrigger value="docs">Documentação</TabsTrigger>
          </TabsList>
          
          <TabsContent value="list">
            <InverterApiList />
          </TabsContent>
          
          <TabsContent value="add">
            <div className="max-w-3xl mx-auto">
              <InverterApiForm />
            </div>
          </TabsContent>
          
          <TabsContent value="docs">
            <div className="max-w-4xl mx-auto">
              <ApiDocsReference />
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
};

export default InverterApiPage;
